import React, {Component} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Index1 from './Pages/Index1';
import About from './Pages/About';
import Ourservices from './Pages/Ourservices';
import Faq from './Pages/Faq';
import Booking from './Pages/Booking';
import Ourmenustyle1 from './Pages/Ourmenustyle1';
import Contact from './Pages/Contact';



class Markup extends Component{
	
	render(){
		return(
			<BrowserRouter basename='/react'>
				<Switch>
					<Route path='/' exact component={Index1} />
					
					<Route path='/about-1' exact component ={About} />
					<Route path='/our-services' exact component ={Ourservices} />
					<Route path='/faq' exact component ={Faq} />
					<Route path='/booking' exact component ={Booking} />
					<Route path='/error-404' exact component ={Error} />
					<Route path='/our-menu-1' exact component ={Ourmenustyle1} />
					<Route path='/contact-1' exact component ={Contact} />

				</Switch>
			</ BrowserRouter>
		)
		
	}
}

export default Markup;